import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PRIVACY_HTML, TERMS_HTML } from "@/lib/legal";

const PAGES = {
  privacidade: { eyebrow: "Legal", title: "Política de Privacidade", html: PRIVACY_HTML },
  termos: { eyebrow: "Legal", title: "Termos e Condições", html: TERMS_HTML },
};

export default function Legal({ page }) {
  const content = PAGES[page];
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${content.title} — Queluz Cardoso`;
  }, [content.title]);

  return (
    <div data-testid={`legal-page-${page}`} className="min-h-screen bg-cream">
      <header className="border-b border-line bg-white/70 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center gap-4 px-5 py-4 sm:px-8">
          <Link data-testid="legal-back-link" to="/" className="rounded-full border border-line p-2 text-fog transition-colors duration-300 hover:text-clay">
            <ArrowLeft size={16} />
          </Link>
          <Link to="/" className="font-display text-lg text-ink">Queluz <span className="text-clay">Cardoso</span></Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-5 py-16 sm:px-8 md:py-24">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.3em] text-clay">{content.eyebrow}</p>
        <h1 className="font-display text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl" data-testid="legal-title">{content.title}</h1>
        <article className="legal-prose mt-12" dangerouslySetInnerHTML={{ __html: content.html }} />
        <div className="mt-16 flex flex-wrap gap-4 text-sm">
          <Link data-testid="legal-link-privacidade" to="/privacidade" className="text-fog underline-offset-4 hover:text-clay hover:underline">Política de Privacidade</Link>
          <Link data-testid="legal-link-termos" to="/termos" className="text-fog underline-offset-4 hover:text-clay hover:underline">Termos e Condições</Link>
          <a data-testid="legal-link-reclamacoes" href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noopener noreferrer" className="text-fog underline-offset-4 hover:text-clay hover:underline">Livro de Reclamações</a>
        </div>
      </main>
    </div>
  );
}
